import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from './../../../environments/environment';
import { CountryModel } from './../models/country.model';

const httpOptions = {
  headers: new HttpHeaders({
    'Content-Type': 'application/json',
  }),
};

@Injectable({
  providedIn: 'root',
})
export class CountryService {
  apiUrl = '/api/v1/country';

  constructor(private http: HttpClient) {
    if (environment.production || environment.test) {
      this.apiUrl = `${environment.bffUrl}${this.apiUrl}`;
    }
  }

  getAll(): Observable<CountryModel[]> {
    return this.http.get<CountryModel[]>(`${this.apiUrl}`);
  }
}
